const STORAGE_PREFIX = 'response_tokens_'

/**
 * Stores the edit token for a guest response
 * @param {string} eventId - The event ID
 * @param {string} responseId - The response ID (for regular events) or name (for sign-up forms)
 * @param {string} editToken - The edit token to store
 */
export function storeResponseEditToken(eventId, responseId, editToken) {
  const key = `${STORAGE_PREFIX}${eventId}_${responseId}`
  localStorage.setItem(key, editToken)
}

/**
 * Retrieves the edit token for a guest response
 * @param {string} eventId - The event ID
 * @param {string} responseId - The response ID (for regular events) or name (for sign-up forms)
 * @returns {string|null} The edit token or null if not found
 */
export function getResponseEditToken(eventId, responseId) {
  const key = `${STORAGE_PREFIX}${eventId}_${responseId}`
  return localStorage.getItem(key)
}

/**
 * Removes the edit token for a guest response
 * @param {string} eventId - The event ID
 * @param {string} responseId - The response ID (for regular events) or name (for sign-up forms)
 */
export function removeResponseEditToken(eventId, responseId) {
  const key = `${STORAGE_PREFIX}${eventId}_${responseId}`
  localStorage.removeItem(key)
}

